import GraphQLClient from 'services/apollo/GraphQLClient';
import DealsQuery from 'services/graphQL/query/DealsQuery';
import ContractMutation from 'services/graphQL/mutate/setting/ContractMutation';

export default class ContractService {
    constructor() {
        this.graphqlClient = new GraphQLClient();
    }

    async getContractsList() {
        return this.graphqlClient
            .query(DealsQuery.GET_CONTRACTS)
            .then((response) => {
                const { data, graphQLErrors } = response;
                if (graphQLErrors) {
                    return { graphQLErrors };
                }

                const { getLoanContractTemplateList } = data;

                return {
                    data: {
                        contractList: getLoanContractTemplateList || [],
                        totalCount: getLoanContractTemplateList?.length || 0,
                    },
                };
            });
    }

    async setDefaultLoanContractTemplate(input) {
        return this.graphqlClient
            .mutate(ContractMutation.SET_DEFAULT_LOAN_CONTRACT_TEMPLATE, input);
    }

    async cloneLoanContractTemplate(input) {
        return this.graphqlClient
            .mutate(ContractMutation.CLONE_LOAN_CONTRACT_TEMPLATE, input);
    }

    async getDealsCountByLoanContractId(input) {
        return this.graphqlClient
            .query(DealsQuery.GET_DEALS_COUNT_BY_LOAN_CONTRACT_ID, input);
    }

    async updateLoanContractTemplate(input) {
        return this.graphqlClient
            .mutate(ContractMutation.UPDATE_LOAN_CONTRACT_TEMPLATE, input);
    }
}
